import axios from "axios";
import { APIGATEWAY } from '../main_config';

export const requestApiManager = ({ headers, ...options }) => {
  return axios({
    baseURL: APIGATEWAY.URL,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    ...options,
  });
};